import { c as _c } from "react/compiler-runtime";
import { createFileRoute, redirect } from '@tanstack/react-router';
import { setSandboxOutcome } from '@/idv2/features/idv-to-idv2';
import { SandboxOutcome } from '@/idv2/features/sandbox-outcome';
import type { SandboxOutcomeFormData } from '@/idv2/features/sandbox-outcome/types';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'sandbox-outcome'
});
export const Route = createFileRoute('/sandbox-outcome')({
  beforeLoad: ({
    context: {
      config,
      overallOutcome,
      idDocOutcome,
      sandboxId
    }
  }) => {
    const needsOverallOutcome = !!config.sandboxConfig?.collectSandboxOutcome && !overallOutcome;
    const needsIdDocOutcome = !!config.sandboxConfig?.collectDocumentOutcome && !idDocOutcome;
    const needsSandboxId = !!config.sandboxConfig?.collectSandboxId && !sandboxId;
    logInfo('Sandbox outcome beforeLoad started', {
      isLive: config.isLive,
      needsOverallOutcome,
      needsIdDocOutcome,
      needsSandboxId
    });
    const shouldShow = !config.isLive && (needsOverallOutcome || needsIdDocOutcome || needsSandboxId);
    if (!shouldShow) {
      logInfo('Sandbox outcome not needed, skipping to identify');
      throw redirect({
        to: '/identify'
      });
    }
    return {
      config,
      sandboxId
    };
  },
  component: SandboxOutcomePage
});
function SandboxOutcomePage() {
  const $ = _c(3);
  const {
    config,
    sandboxId
  } = Route.useRouteContext();
  const handleSubmit = _temp;
  let t0;
  if ($[0] !== config || $[1] !== sandboxId) {
    t0 = <SandboxOutcome config={config} sandboxId={sandboxId} onSubmit={handleSubmit} />;
    $[0] = config;
    $[1] = sandboxId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp(data) {
  logInfo("Sandbox outcome submitted", {
    overallOutcome: data.overallOutcome,
    hasIdDocOutcome: !!data.idDocOutcome,
    hasSandboxId: !!data.testID
  });
  setSandboxOutcome({
    overallOutcome: data.overallOutcome,
    fixtureRiskSignals: data.fixtureRiskSignals,
    idDocOutcome: data.idDocOutcome as string | undefined,
    sandboxId: data.testID
  });
}